// Constants shared between the arcade hub and the games.
//
// The hub must stay tiny and game-free. Importing GameConfig just to read the
// level total dragged in PlayerConfig (including its jump-arc simulator) and
// MathUtil, and importing SaveSystem for one string pulled the whole save
// engine. Both live here instead so the hub imports data, not machinery.
//
// SAVE_MIRROR_KEY is load-bearing: renaming it orphans every existing player's
// progress, so it keeps the original `park-gentlemen` namespace even though the
// game inside is branded Skyline.

export const TOTAL_LEVELS = 1000;
export const SAVE_MIRROR_KEY = 'park-gentlemen:save-mirror';
